module.exports = __webpack_public_path__ + "static/media/efi.82473004.png";